import React from "react";
import ProjectsSection from "../components/ProjectsSection";

export default function Projects() {
  return (
    <section
      id="projects"
      className="w-full bg-light dark:bg-dark text-black dark:text-white py-24"
    >
      <div className="max-w-5xl mx-auto px-4">
        <div className="flex items-baseline gap-4 mb-12">
          <span className="font-mono text-[13px] text-accent">03</span>
          <h2 className="text-3xl font-bold tracking-tight">Projects</h2>
          <span className="flex-1 h-px bg-black/10 dark:bg-white/10" />
        </div>
        <ProjectsSection />
      </div>
    </section>
  );
}
